import CasesFirstView from './CasesFirstView'

export default CasesFirstView
